var map = {
	"./en/about.json": 4014,
	"./en/appro.json": 8075,
	"./en/character.json": 5284,
	"./en/docs.json": 5610,
	"./en/faq.json": 6367,
	"./en/features.json": 1698,
	"./en/help.json": 1922,
	"./en/home.json": 4174,
	"./en/language.json": 1471,
	"./en/organizers.json": 3231,
	"./en/partners.json": 7710,
	"./en/testimonials.json": 1177,
	"./en/ui.json": 8479,
	"./en/world.json": 6599,
	"./fi/language.json": 5605,
	"./sv/language.json": 5301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4178;